import script from "./CaseBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseBlock.vue?vue&type=script&setup=true&lang=js"

import "./CaseBlock.vue?vue&type=style&index=0&id=e11e9256&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11e9256"]])

export default __exports__